<template>
	<div >
		<vs-card v-if="!mostrarPerguntas">
			<div slot="header">
				<h3>Dados do Atendimento</h3>
			</div>
			<div>
				<vs-row>
					<vs-col
						class="mb-2"
						vs-type="flex"
						vs-justify="center"
						vs-align="center"
						vs-lg="6"
						vs-sm="6"
						vs-xs="12"
					>
						<vs-input
							class="w-full"
							label="Responsável pelo atendimento"
							v-model="form.responsavel"
							name="Responsavel"
							v-validate="{ required: true }"
							:state="validateState('Responsavel')"
							:class="validateClass('Responsavel')"
						/>
					</vs-col>
					<vs-col class="mb-2" vs-lg="6" vs-sm="6" vs-xs="12">
						<label for="" class="vs-select--label"> Data e Hora </label>
						<flat-pickr
							:config="configdateTimePicker"
							v-model="form.dataHora"
							placeholder="DD/MM/YYYY HH:MM"
							class="w-full flat-Pickr"
							:class="flatPickrDataHora ? '' : 'flatpickr-danger'"
							name="Data e Hora"
							v-validate="{ required: true }"
							:state="validateState('Data e Hora')"
							:danger="validateClass('Data e Hora')"
						/>
					</vs-col>
				</vs-row>
				<vs-row>
					<vs-col class="mb-2" vs-lg="6" vs-sm="6" vs-xs="12">
						<vs-input
							id="DiaSemana"
							name="Dia da Semana"
							label="Dia da Semana"
							v-model="form.diaSemana"
							class="w-full"
							v-validate="{ required: true }"
							:state="validateState('Dia da Semana')"
							:class="validateClass('Dia da Semana')"
							disabled
						/>
					</vs-col>
					<vs-col class="mb-2" vs-lg="6" vs-sm="6" vs-xs="12">
						<vs-input
							id="Protocolo"
							name="Protocolo"
							label="Protocolo WebAssist"
							v-model="form.protocoloWebAssist"
							class="w-full"
							v-validate="{ required: true }"
							:state="validateState('Protocolo')"
							:class="validateClass('Protocolo')"
						/>
					</vs-col>
				</vs-row>
			</div>
		</vs-card>
		<vs-card v-if="!mostrarPerguntas">
			<div slot="header">
				<h3>Dados do Acioante</h3>
			</div>
				<vs-row>
					<vs-col
						class="mt-4 mb-4"
						vs-type="flex"
						vs-justify="center"
						vs-align="center"
						vs-w="12"
					>
						<h4 :class="radioTipo ? 't-h4' : 't-h4-danger'">Tipo do Acionante</h4>
					</vs-col>
				</vs-row>
				<vs-row>
					<vs-col class="gap-5 mb-4" vs-type="flex" vs-justify="center" vs-align="center">
						<vs-radio
							v-for="tipo in tiposAcionante"
							:key="tipo.nome"
							v-model="form.tipoAcionante"
							name="Tipo"
							:vs-name="tipo.nome"
							:vs-value="tipo.valor"
							v-validate="{ required: tipo.required }"
							:state="validateState('Tipo')"
							:class="validateClass('Tipo')"
							>{{ tipo.nome }}
						</vs-radio>
					</vs-col>
				</vs-row>
				<vs-row>
					<vs-col
						class="mb-2"
						vs-type="flex"
						vs-justify="center"
						vs-align="center"
						vs-lg="6"
						vs-sm="6"
						vs-xs="12"
					>
						<vs-input
							class="w-full"
							label="Nome"
							v-model="form.nome"
							name="Nome"
							v-validate="{ required: true }"
							:state="validateState('Nome')"
							:class="validateClass('Nome')"
						/>
					</vs-col>
					<vs-col
						class="mb-2"
						vs-type="flex"
						vs-justify="flex-start"
						vs-align="center"
						vs-lg="6"
						vs-sm="6"
						vs-xs="12"
					>
						<vs-input
							id="telefone"
							name="Telefone"
							label="Telefone"
							v-model="form.telefone"
							class="w-full"
							v-mask="escolherTelMask()"
							v-validate="{ required: true, min: 14 }"
							:state="validateState('Telefone')"
							:class="validateClass('Telefone')"
						/>
					</vs-col>
				</vs-row>
				<vs-row>
					<vs-col
						class="mb-2"
						vs-type="flex"
						vs-justify="center"
						vs-align="center"
						vs-lg="6"
						vs-sm="6"
						vs-xs="12"
					>
						<vs-input
							id="marca"
							name="Marca"
							label="Veículo(Marca/Modelo)"
							v-model="form.marcaModelo"
							class="w-full"
							v-validate="{ required: true }"
							:state="validateState('Marca')"
							:class="validateClass('Marca')"
						/>
					</vs-col>
					<vs-col
						class="mb-2"
						vs-type="flex"
						vs-justify="flex-start"
						vs-align="center"
						vs-lg="6"
						vs-sm="6"
						vs-xs="12"
					>
						<vs-input
							id="placa"
							name="Placa"
							label="Placa"
							v-model="form.placa"
							class="w-full"
							v-validate="{ required: true, min: 8 }"
							v-mask="'AAA-#XX#'"
							:state="validateState('Placa')"
							:class="validateClass('Placa')"
						/>
					</vs-col>
				</vs-row>
				<vs-row>
					<vs-col class="mb-2">
						<vs-input
							id="localEveto"
							name="Local do Evento"
							label="Local do evento"
							v-model="form.localEvento"
							class="w-full"
							v-validate="{ required: true }"
							:state="validateState('Local do Evento')"
							:class="validateClass('Local do Evento')"
						/>
					</vs-col>
				</vs-row>
				<vs-row>
					<vs-col
						class="mt-4 mb-4"
						vs-type="flex"
						vs-justify="center"
						vs-align="center"
						vs-w="12"
					>
						<h4 :class="radioMotivo ? 't-h4' : 't-h4-danger'">Motivo do Evento</h4>
					</vs-col>
				</vs-row>
				<vs-row class="">
					<vs-col
						class="mb-2"
						v-for="motivo in motivosEvento"
						:key="motivo.nome"
						vs-type="flex"
						vs-justify="flex-start"
						vs-align="center"
						vs-w="2.4"
						vs-sm="6"
						vs-xs="6"
					>
						<vs-radio
							:key="motivo.nome"
							v-model="form.motivo"
							:vs-name="motivo.nome"
							:vs-value="motivo.valor"
							v-validate="{ required: motivo.required }"
							name="Motivo"
							:state="validateState('Motivo')"
							:class="validateClass('Motivo')"
							>{{ motivo.nome }}
						</vs-radio>
					</vs-col>
				</vs-row>
				<vs-row>
					<vs-col class="w-full text-right">
						<vs-button
							color="dark"
							@click="ValidaCampos()"
							type="gradient"
							class="mt-2 mb-2"
						>
							Salvar e ir para perguntas
						</vs-button>
					</vs-col>
				</vs-row>
				<vs-alert
					v-if="$validator.errors.all().length > 0"
					color="danger"
					title="Atenção"
					active="true"
					class="my-3"
					style="height: auto !important"
				>
					<ul>
						<li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">
							{{ error }}
						</li>
					</ul>
				</vs-alert>
		</vs-card>
		<formChecklistPerguntas  v-else :idEmpresa="form.idEmpresa" :idChecklist="idChecklist" :motivo="form.motivo"/>
	</div>
</template>

<script>
import moment from "moment";
import locale from "../../locale";
import jwt from "jsonwebtoken";
import flatPickr from "vue-flatpickr-component";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import service from "../../services/index";
import formChecklistPerguntas from "./eventos/formChecklistPerguntas.vue";

export default {
	data() {
		const tiposAcionante = [
			{ nome: "Associado", valor: "Associado", required: true },
			{ nome: "Outro", valor: "Outro", required: false },
		];
		const motivosEvento = [
			{ nome: "Colisão", valor: "Colisao", required: true },
			{ nome: "Roubo", valor: "Roubo", required: false },
			{ nome: "Furto", valor: "Furto", required: false },
			{ nome: "Incendio", valor: "Incendio", required: false },
			{ nome: "Danos da Natureza", valor: "DanosNatureza", required: false },
		];
		const diasSemana = [
			"Domingo",
			"Segunda-Feira",
			"Terça-Feira",
			"Quarta-Feira",
			"Quinta-Feira",
			"Sexta-feira",
			"Sábado",
		];
		const form = {
			idEmpresa: null,
			idUsuario: null,
			responsavel: null,
			dataHora: null,
			diaSemana: null,
			protocoloWebAssist: null,
			tipoAcionante: null,
			nome: null,
			telefone: '',
			marcaModelo: null,
			placa: null,
			localEvento: null,
			motivo: null,
		};
		const configdateTimePicker = {
			enableTime: true,
			dateFormat: "d/m/Y H:i",
			locale: Portuguese,
			time_24hr: true,
		};
		return {
			radioTipo: true,
			radioMotivo: true,
			diasSemana,
			flatPickrDataHora: true,
			idChecklist: null,
			tiposAcionante,
			motivosEvento,
			form,
			configdateTimePicker,
			mostrarPerguntas: false,
		};
	},
	methods: {
		decodificarToken() {
			const { id_usuario, id_empresa } = jwt.decode(localStorage.getItem("user-token"));
			this.form.idEmpresa = id_empresa;
			this.form.idUsuario = id_usuario;
		},
		setDiaSemana(date) {
			moment.locale("pt");
			const numDiaDemana = moment(date.slice(0, 10).split("/").reverse().join("-")).day();
			this.form.diaSemana = this.diasSemana[numDiaDemana];
		},
		validateState(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				return !this.veeErrors.has(ref);
			}
			return null;
		},
		validateClass(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				return this.veeErrors.has(ref) ? "has-error" : "";
			}
			return null;
		},
		async ValidaCampos() {
			await this.$validator.validateAll(), this.validateRadios(), this.validaFlatPickr();
			if (this.$validator.errors.all().length === 0) {
				this.salvarChecklist();
			}
		},
		validateRadios() {
			this.radioTipo = this.form.tipoAcionante;
			this.radioMotivo = this.form.motivo;
		},
		validaFlatPickr() {
			this.flatPickrDataHora = this.form.dataHora;
		},
		escolherTelMask(){
			return this.form.telefone.length <= 14 ? '(##) ####-####' : '(##) # ####-####'
		},
		salvarChecklist() {
			this.$vs.loading();
			service
				.post("Checklist", "/registrarChecklist", this.form)
				.then((res) => {
					this.$vs.notify({
						position: "top-center",
						title: "Atenção",
						text: "Checklist salvo com sucesso",
						color: "success",
					});
					console.log(res.data);
					this.idChecklist = res.data.idChecklist;
					this.$vs.loading.close();
					this.irParaPerguntas();
				})
				.catch((e) => {
					this.$vs.notify({
						position: "top-center",
						title: "Atenção",
						text: e,
						color: "danger",
					});
					this.$vs.loading.close();
				});
		},
		irParaPerguntas() {
			this.mostrarPerguntas = !this.mostrarPerguntas;
		},
		
	},
	watch: {
		"form.tipoAcionante": function (/*novo,antigo*/) {
			this.radioTipo = this.form.tipoAcionante;
		},
		"form.motivo": function (/*novo,antigo*/) {
			this.radioMotivo = this.form.motivo;
		},
		"form.dataHora": function () {
			this.flatPickrDataHora = this.form.dataHora;
			this.setDiaSemana(this.form.dataHora);
		}
	},
	created() {
		this.$validator.localize("ptBr", locale);
		this.decodificarToken();
	},
	mounted() {},
	components: {
		flatPickr,
		formChecklistPerguntas,
	},
};
</script>

<style scoped>
.table-bordered {
	display: table;
	border-collapse: separate;
	box-sizing: border-box;
	border-spacing: 2px;
	border-color: grey;
	width: 100%;
}
tr td {
	padding: 2px;
}
tr:nth-child(odd) {
	background: #efefef !important;
}

.t-h4 {
	color: rgb(99, 99, 99);
	font-size: 1.3em;
}

.t-h4-danger {
	color: rgb(234, 85, 86);
	font-size: 1.3em;
}

.gap-5 {
	gap: 5em !important;
}

.vdp-datepicker input {
	width: 100%;
}

.vdp-datepicker__calendar {
	z-index: 900 !important;
}

.flatpickr-danger {
	border: 1px solid red !important;
}

.flat-Pickr {
	padding: 0.7rem;
	font-size: 1rem;
	border-radius: 5px;
	border: 1px solid rgba(0, 0, 0, 0.2);
	color: #626262;
}
</style>
